import { b as __read, c as __assign } from './chunks/tslib.es6-b10543c1.js';
import React__default, { memo, useRef } from 'react';
import { Typography, Icon, Portal, Badge } from '@sravni/react-design-system';
import { Fade } from '@sravni/react-design-system/lib/Transition';
import { useStyles, useBoolean, usePositioner } from '@sravni/react-utils';

var modules_af19274f = {"bubble":"_1qdpprl","arrow":"_16u3cxh","content":"_mi9457","iconWrapper":"_1cuovbi"};
import "./assets/PartnerBadge.css";

var Verification = function (_a) {
    var className = _a.className;
    return (React__default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 18 18", fill: "none", className: className },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m9.319 2.21 2.041-.66a1.034 1.034 0 0 1 1.24.513l.975 1.911c.1.194.257.352.451.45l1.887.965c.466.237.69.779.529 1.277l-.653 2.016c-.066.207-.066.43 0 .637l.661 2.041a1.034 1.034 0 0 1-.513 1.24l-1.911.975a1.035 1.035 0 0 0-.45.45l-.977 1.912c-.231.452-.756.67-1.24.513l-2.04-.661a1.038 1.038 0 0 0-.638 0l-2.041.66a1.034 1.034 0 0 1-1.239-.512l-.976-1.911a1.035 1.035 0 0 0-.45-.451l-1.912-.977a1.033 1.033 0 0 1-.513-1.239l.661-2.041c.067-.207.067-.43 0-.637l-.66-2.04a1.035 1.035 0 0 1 .513-1.24l1.91-.976a1.03 1.03 0 0 0 .451-.45l.977-1.912c.23-.451.756-.669 1.239-.513l2.041.66c.206.068.43.068.637 0Z", fill: "#00AFFF", stroke: "#00AFFF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.8 6.468a.562.562 0 0 1 .909.655l-.06.083-3.907 4.5a.563.563 0 0 1-.725.107l-.082-.064-2.843-2.637a.563.563 0 0 1 .685-.887l.08.062 2.417 2.242L11.8 6.468Z", fill: "#fff" })));
};

var Heading = Typography.Heading, Text = Typography.Text;
var PartnerBadge$1 = memo(function (_a) {
    var children = _a.children;
    var cx = useStyles(modules_af19274f);
    var reference = useRef(null);
    var popper = useRef(null);
    var _b = __read(useBoolean(false), 2), visible = _b[0], setVisible = _b[1];
    var minWidthModifier = {
        name: 'minWidth',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function (_a) {
            var state = _a.state;
            state.styles.popper.minWidth = '280px';
        }
    };
    var _c = usePositioner({
        placement: 'bottom-start',
        modifiers: [
            minWidthModifier,
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['top', 'right', 'bottom', 'left']
                }
            },
        ]
    }), referenceRef = _c.referenceRef, popperRef = _c.popperRef, arrowRef = _c.arrowRef, getReferenceProps = _c.getReferenceProps, getPopperProps = _c.getPopperProps;
    React__default.useEffect(function () {
        // @ts-ignore
        var timer = null;
        var listener = function (event) {
            var _a, _b, _c;
            // @ts-ignore
            if (!visible && ((_a = reference.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setVisible.on();
            }
            // @ts-ignore
            if (visible && !((_b = reference.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)) && !((_c = popper.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))) {
                timer = setTimeout(function () {
                    setVisible.off();
                }, 50);
            }
        };
        document.addEventListener('mouseover', listener);
        return function () {
            // @ts-ignore
            timer && clearTimeout(timer);
            document.removeEventListener('mouseover', listener);
        };
    }, [reference, popper, setVisible, visible]);
    var trigger = (React__default.createElement("div", __assign({ ref: referenceRef }, getReferenceProps({}, reference), { className: modules_af19274f.iconWrapper }),
        React__default.createElement(Icon, { icon: React__default.createElement(Verification, null) })));
    var tooltip = (React__default.createElement(Portal, null,
        React__default.createElement(Fade, __assign({ ref: popperRef, className: cx('bubble'), visible: visible, unmountOnExit: true }, getPopperProps({ style: { zIndex: 1060 } }, popper)),
            React__default.createElement("div", { ref: arrowRef, className: cx('arrow') }),
            React__default.createElement("div", { className: modules_af19274f.content },
                React__default.createElement(Heading, { level: 5, className: "h-mb-4" }, "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u0442\u043D\u0451\u0440 \u0421\u0440\u0430\u0432\u043D\u0438."),
                React__default.createElement(Text, { size: 14 },
                    "\u042D\u0442\u043E\u0442 \u0437\u043D\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043C\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B. \u041D\u0430\u0448\u0438 \u043C\u043E\u0434\u0435\u0440\u0430\u0442\u043E\u0440\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u043B\u0438 ",
                    React__default.createElement("span", null, "\u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B\u0438"),
                    ' ',
                    "\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0431 \u0438\u0445 \u0443\u0441\u043B\u0443\u0433\u0430\u0445. \u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u0438 \u044D\u0442\u0438\u0445 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0439 \u043E\u0442\u0432\u0435\u0447\u0430\u044E\u0442 ",
                    React__default.createElement("span", null, "\u043D\u0430 \u043E\u0442\u0437\u044B\u0432\u044B"),
                    " \u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0421\u0440\u0430\u0432\u043D\u0438 \u0432 \u043F\u0435\u0440\u0432\u0443\u044E \u043E\u0447\u0435\u0440\u0435\u0434\u044C.")))));
    return (React__default.createElement("div", { className: modules_af19274f.badgeWrapper },
        React__default.createElement(Badge, { color: "white", text: trigger, shape: "circle", placement: "bottom-end" }, children),
        tooltip));
});

export { PartnerBadge$1 as PartnerBadge };
